import React from "react";
import {
  Users,
  FolderKanban,
  ClipboardList,
  FileCheck,
  UserCheck,
  Clock,
} from "lucide-react";
import StatCard from "./StatCard";
import { DashboardOverview } from "../../../lib/api/dashboard";

interface QuickStatsGridProps {
  data?: DashboardOverview;
  loading?: boolean;
}

const QuickStatsGrid: React.FC<QuickStatsGridProps> = ({ data, loading }) => {
  const stats = [
    {
      title: "Total Users",
      value: data?.users.total ?? 0,
      subtitle: `${data?.users.newThisWeek ?? 0} new this week`,
      icon: Users,
      iconColor: "text-blue-600",
      iconBgColor: "bg-blue-50",
      trend:
        data?.trends.userGrowth.changePercent !== undefined
          ? { value: data.trends.userGrowth.changePercent }
          : undefined,
    },
    {
      title: "Active Projects",
      value: data?.projects.active ?? 0,
      subtitle: `${data?.projects.total ?? 0} total projects`,
      icon: FolderKanban,
      iconColor: "text-purple-600",
      iconBgColor: "bg-purple-50",
      trend:
        data?.trends.projectGrowth.changePercent !== undefined
          ? { value: data.trends.projectGrowth.changePercent }
          : undefined,
    },
    {
      title: "Pending Applications",
      value: data?.applications.pending ?? 0,
      subtitle: `${data?.applications.approvalRate ?? 0}% approval rate`,
      icon: ClipboardList,
      iconColor: "text-amber-600",
      iconBgColor: "bg-amber-50",
      trend:
        data?.trends.applicationGrowth.changePercent !== undefined
          ? { value: data.trends.applicationGrowth.changePercent }
          : undefined,
    },
    {
      title: "Active Assignments",
      value: data?.assignments.active ?? 0,
      subtitle: `${data?.assignments.completed ?? 0} completed`,
      icon: FileCheck,
      iconColor: "text-emerald-600",
      iconBgColor: "bg-emerald-50",
    },
    // {
    //   title: "Total Revenue",
    //   value: formatCurrency(data?.revenue.totalEstimatedValue ?? 0),
    //   subtitle: `Avg $${data?.revenue.avgHourlyRate ?? 0}/hr`,
    //   icon: DollarSign,
    //   iconColor: "text-green-600",
    //   iconBgColor: "bg-green-50",
    // },
    {
      title: "Profile Completion",
      value: `${data?.users.profileCompletionRate ?? 0}%`,
      subtitle: `${data?.users.active ?? 0} verified users`,
      icon: UserCheck,
      iconColor: "text-indigo-600",
      iconBgColor: "bg-indigo-50",
    },
    {
      title: "Avg Response Time",
      value: `${data?.applications.avgResponseTime ?? 0}h`,
      subtitle: "Application review time",
      icon: Clock,
      iconColor: "text-rose-600",
      iconBgColor: "bg-rose-50",
    },
    // {
    //   title: "Utilization Rate",
    //   value: `${data?.projects.utilizationRate ?? 0}%`,
    //   subtitle: `${data?.projects.filledSlots ?? 0}/${data?.projects.totalSlots ?? 0} slots filled`,
    //   icon: TrendingUp,
    //   iconColor: "text-cyan-600",
    //   iconBgColor: "bg-cyan-50",
    // },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          title={stat.title}
          value={stat.value}
          subtitle={stat.subtitle}
          icon={stat.icon}
          iconColor={stat.iconColor}
          iconBgColor={stat.iconBgColor}
          trend={stat.trend}
          loading={loading}
        />
      ))}
    </div>
  );
};

export default QuickStatsGrid;
